{
    "title": {
        "bannerSubscriptionRenovation": "Renovation Subscription Banner",
        "homePage": "Home Page",
        "gift": "Gift SUBSCRIPTION+",
        "buy": "Buy SUBSCRIPTION+",
        "register": "Register",
        "purchaseConfirmation": "Purchase confirmation",
        "nonSubscriberQuestions": "Non subscriber questions",
        "nonSubscriberAnswers": "Non subscriber answers",
        "cart": "Purchase ABONOTEATRO (Make a purchase) ",
        "legalConditions": "General conditions",
        "legalPrivacy": "Privacy policy",
        "legalCookies": "Cookies policy",
        "legalNotice": "Legal notice",
        "faqs": "FAQs"
    }
}
